let index = 2001;

const styles = `
.hpp-dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.hpp-dialog__mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
}

.hpp-dialog__container {
  animation: pop-in 0.5s alternate;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes pop-in {
  0% {
    transform: translate(-50%, -50%) scale3d(0.5, 0.5, 0.5);
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
`;
const elStyle = document.createElement('style');
elStyle.innerHTML = styles;
document.head.appendChild(elStyle);

/**
 * @param {HTMLElement} elContainer
 * @param {{destroyOnClose: boolean}} config
 */
function useDialog(elContainer, config = {}) {
  let elDialog = document.createElement('div');
  const elMask = document.createElement('div');

  elDialog.classList.add('hpp-dialog');
  elMask.classList.add('hpp-dialog__mask');
  elContainer.classList.add('hpp-dialog__container');

  elDialog.appendChild(elMask);
  elDialog.appendChild(elContainer);

  elDialog.style.zIndex = index++;

  return {
    get el() {
      return elDialog;
    },
    open: () => {
      document.body.appendChild(elDialog);
    },
    close: () => {
      elDialog.remove();
      if (config.destroyOnClose) {
        elDialog = null;
      }
    }
  };
}

export default useDialog;
